import { numberGames } from '@/constants';

export const getNumberPointsPerGame = (totalPoints: number) =>
  totalPoints / numberGames;
